import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-getdeptinfo-ath';

import {
resetAction as SubjectSeletcedReset
} from 'one-state-subjectselected/src/actions';

import {
resetAction as SourceSelectedReset
} from 'one-state-sourceselected/src/actions'

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setError as setApptError,
    addDepartmentAthena
    } from 'one-state-appointments'
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    GETDEPTINFO_FETCH = "department-info-fetch/athena",
    SETSELECTED_ATHENA = 'one-state-subject/setselected-athena',
    SETAPPOINTMENTS = 'set-appointments/set-athena',
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of GetSession
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetDeptInfoAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,teamName, settings: {
            athenaendpoints: {
                getdepartmentinfo
            },
            uisettings: {
                dashboardapiconfig: {
                    getdeptinfo : getdeptinfoApi
                }
            },
            compatible : { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETDEPTINFO_FETCH),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient Medical history response
                 */
                let dataresponse: any = action.payload;

                const callProviderInfoAPI = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        const responsefromAPI = server.get({
                            headers: headers,
                            path: getdepartmentinfo + "?DepartmentID=" + (datares?.departmentID)
                        })
                            .then((responsegetdeptinfo: any) => responsegetdeptinfo)
                            .catch((getdeptinfores: any) => {
                                log.error(
                                    "ccw-gadget,getdeptinfo-athena",
                                    "getdeptinfo-athena", {
                                        getdeptinfores
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"GetDeptInfo",
                                    type:"error",
                                    status:getdeptinfores?.status,
                                    erroritems:getdeptinfores?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,getdeptinfo-athena",
                            "getdeptinfo-athena response", {
                            responsefromAPI
                        });
                        return from(responsefromAPI)
                    } else {
                        return from([]);
                    }

                }
                //Calling callMedicalhistoryAPI function here
                //the reason is we need to use pipe function.
                if (!getdeptinfoApi) return []
                return callProviderInfoAPI(dataresponse).
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions:any = [];
                                if (responseAfterTransform.error) {
                                    switch (action.type) {
                                        case Types.GETDEPTINFO_FETCH:
                                            actions.push(setApptError(responseAfterTransform.error))
                                            break;
                                    }
                                    actions.push(addAction(responseAfterTransform.error));
                                } else {
                                    switch (action.type) {
                                        case Types.GETDEPTINFO_FETCH:
                                            let dataobj  = {
                                                apptid: dataresponse.apptID,
                                                getdeptinfo: responseAfterTransform.getdeptinfo
                                            }
                                            actions.push(addDepartmentAthena(dataobj));
                                            break;
                                    }
                                }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
export const clearGetDeptInfoAthena = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, getproviderinfo-athena",
            "clear-getproviderinfo-athena", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, Types.SETSELECTED_ATHENA),
            map(action => resetAction())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSubSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSub-epic",
            "clear-selectedSub-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SubjectSeletcedReset())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for GetSession
 * @param context  contains logger which is used for logging
 */
 export const clearSelectedSourceSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, selectedSource-epic",
            "clear-selectedSource-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET,SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => SourceSelectedReset())
        )

    }
);